import { useMemo } from 'react';
import {
  Link,
  NavLink,
  useLocation,
  useNavigate,
  useParams,
  useSearchParams,
} from 'react-router-dom';

import { ModuleContextDef } from '../../modules/shared/moduleContext/types.ts';
import { useToolkitControllerGlobal } from './useToolkitControllerGlobal.ts';

export const useNewModule = (expectOrder: boolean, expectGlobal: boolean): ModuleContextDef => {
  // const referenceBarUI = useReferenceBarUserInterface(!expectRefBar);
  const toolkitGlobal = useToolkitControllerGlobal(!expectGlobal);
  // const order = useToolkitControllerOrderGlobal(!expectOrder);

  return useMemo(
    () => ({
      // referenceBarUI,
      toolkitGlobal,
      // order,
      navigation: {
        Link,
        NavLink,
        useLocation,
        useNavigate,
        useParams,
        useSearchParams,
        openPopup: window.open,
      },
    }),
    // [order, referenceBarUI, toolkitGlobal]
    [toolkitGlobal],
  );
};
